import { To, useLocation, useNavigate } from 'react-router';

// TODO: Remove this hook. It is formerly provided by the Minimals template.

export const useNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navigateWithPrevPath = (to: To, prev?: { state?: Record<string, unknown> }) =>
    navigate(to, { state: { ...(prev?.state ?? {}), prevPath: location.pathname } });

  return { navigateWithPrevPath };
};
